import { getLogger } from "@expert/logging";

import type { MessageSender } from "@/sdk/agent/chat/types";

import { MESSAGE_SENDER_TYPES } from "@/sdk/agent/chat/types";

import type { ChatMessagePayload } from "../types";

const logger = getLogger({ module: "amazon-connect-message-validator" });

/** Type guard to check if a value is a valid MessageSender. */
function isValidSenderType(value: unknown): value is MessageSender {
    return typeof value === "string" && MESSAGE_SENDER_TYPES.includes(value as MessageSender);
}

/**
 * Type guard to validate ChatMessagePayload structure.
 * Validates all required fields are present and properly typed.
 */
export function isValidMessageContent(parsed: unknown, messageId: string): parsed is ChatMessagePayload {
    if (!parsed || typeof parsed !== "object") {
        logger.warn({ messageId, parsed }, "Message content is not an object");
        return false;
    }

    const content = parsed as Partial<ChatMessagePayload>;
    const errors: string[] = [];

    if ((!content.body || typeof content.body !== "string") && content.triggeredComponent !== "salesDisclosure") {
        errors.push("body");
    }
    if (!content.author || typeof content.author !== "string") {
        errors.push("author");
    }
    if (!isValidSenderType(content.senderType)) {
        errors.push(`senderType (received: ${content.senderType})`);
    }
    if (!content.sourceApp || typeof content.sourceApp !== "string") {
        errors.push("sourceApp");
    }
    if (!content.partner || typeof content.partner !== "string") {
        errors.push("partner");
    }
    if (!content.type || typeof content.type !== "string") {
        errors.push("type");
    }
    if (!content.topic || typeof content.topic !== "string") {
        errors.push("topic");
    }
    if (!content.language || typeof content.language !== "string") {
        errors.push("language");
    }

    if (errors.length > 0) {
        logger.warn({ messageId, missingOrInvalidFields: errors, content }, "Message content validation failed");
        return false;
    }

    return true;
}
